import { useTranslation } from "react-i18next";
import { Link } from "react-router-dom";

export default function ArticlePreviewSection() {
  const { t } = useTranslation();

  return (
    <section className="w-full py-16 md:py-20 px-4 md:px-10 bg-background-100">
      <div className="max-w-7xl mx-auto">
        <div className="flex flex-col lg:flex-row items-center gap-10 lg:gap-16">
          {/* Left: Image */}
          <div className="w-full lg:w-1/2">
            <Link
              to="/artykul/jak-korzystac-z-kakobuy-spreadsheet"
              className="block rounded-2xl overflow-hidden cursor-pointer group"
            >
              <div className="aspect-[4/3] overflow-hidden rounded-2xl">
                <img
                  src="https://readdy.ai/api/search-image?query=Modern%20minimalist%20workspace%20with%20an%20iMac%20displaying%20a%20colorful%20organized%20spreadsheet%20with%20product%20thumbnails%2C%20surrounded%20by%20carefully%20arranged%20product%20photography%20samples%20on%20a%20light%20oak%20desk%2C%20ceramic%20coffee%20mug%20with%20latte%20art%2C%20small%20potted%20snake%20plant%2C%20soft%20diffused%20morning%20light%20through%20sheer%20linen%20curtains%2C%20warm%20and%20inviting%20creative%20studio%20atmosphere%2C%20editorial%20interior%20photography%2C%20warm%20beige%20cream%20and%20soft%20green%20tones%2C%20high%20attention%20to%20detail&width=1200&height=900&seq=kakobuy-article-preview-v2&orientation=landscape"
                  alt="Kompletny przewodnik kakobuy spreadsheet"
                  title="Przewodnik Kakobuy Spreadsheet 2026"
                  className="w-full h-full object-cover group-hover:scale-105 transition-transform duration-700"
                />
              </div>
            </Link>
          </div>

          {/* Right: Text + CTA */}
          <div className="w-full lg:w-1/2 text-center lg:text-left">
            <span className="inline-block px-3 py-1 rounded-full bg-accent-100 text-accent-800 text-xs font-medium mb-4">
              {t("article.readTime")}
            </span>
            <h2 className="font-heading text-3xl md:text-4xl lg:text-5xl font-bold text-foreground-900 leading-[1.15] mb-3">
              <span className="block">{t("article.title1")}</span>
              <span className="block font-normal italic text-foreground-400 text-2xl md:text-3xl lg:text-4xl">
                {t("article.title2")}
              </span>
              <span className="block">{t("article.title3")}</span>
            </h2>
            <p className="text-sm text-foreground-500 mb-8">
              {t("article.author")} &middot; {t("article.updated")}
            </p>
            <p className="text-foreground-600 leading-relaxed mb-8 text-sm md:text-base max-w-md mx-auto lg:mx-0">
              Dowiedz się wszystkiego o korzystaniu z arkusza Kakobuy — od podstaw po zaawansowane techniki.
              Poznaj najlepsze kategorie, porównaj ceny i jakość produktów oraz naucz się unikać
              najczęstszych błędów przy zamówieniach z Chin.
            </p>
            <Link
              to="/artykul/jak-korzystac-z-kakobuy-spreadsheet"
              className="inline-flex items-center gap-2 px-6 py-3 rounded-full font-semibold text-sm transition-all cursor-pointer whitespace-nowrap bg-foreground-950 text-background-50 hover:bg-foreground-800"
            >
              {t("article.cta")}
              <i className="ri-arrow-right-line"></i>
            </Link>
          </div>
        </div>
      </div>
    </section>
  );
}